const Chat = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 2C14.6667 2 18 5.33333 18 9.5C18 13.6667 14.6667 17 10.5 17H3.83301C3.49989 16.9999 3.3336 16.8329 3.16699 16.583C3.00038 16.333 3.00034 16 3.16699 15.75L4.33301 13.75C3.49973 12.5 3 10.9999 3 9.5C3 5.33333 6.33333 2 10.5 2ZM10.5 3.66699C7.25 3.66699 4.66699 6.25 4.66699 9.5C4.66699 10.8333 5.16667 12.167 6 13.167C6.2498 13.4169 6.24957 13.7498 6.08301 14.083L5.33301 15.333H10.5C13.75 15.333 16.333 12.75 16.333 9.5C16.333 6.25 13.75 3.66699 10.5 3.66699ZM13.0049 10.333C13.5049 10.333 13.8389 10.667 13.8389 11.167C13.8387 11.6668 13.5047 12 13.0049 12H8.00488C7.5052 11.9999 7.17206 11.6667 7.17188 11.167C7.17188 10.6671 7.50506 10.3332 8.00488 10.333H13.0049ZM10.5049 7C11.0048 7 11.3387 7.33319 11.3389 7.83301C11.3389 8.33301 11.0049 8.66699 10.5049 8.66699H8.00488C7.50506 8.66685 7.17188 8.3329 7.17188 7.83301C7.17202 7.3333 7.50517 7.00014 8.00488 7H10.5049Z"
        fill="black"
      />
    </svg>
  );
};

export default Chat;
